import React from 'react';
import {
  Link
} from "react-router-dom";
import { 
  Container,
  Row,
  Col,
  Card,
  CardColumns
} from 'react-bootstrap';

class Persons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      userid: 'paalth@gmail.com'
    };
  }
  
  componentDidMount() {
    fetch(window._env_.API_URL + '/persons', {
      headers: {
        'Authorization': window._env_.FRONTEND_TOKEN,
        'UserId': this.state.userid
      }
    }).then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  render() {
    const { error, isLoaded, items } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <div>Loading...</div>;
    } else {
      return (
        <Container>
          <Row>
            <Col>
              <h1>Persons</h1>
            </Col>
            <Col>
            &nbsp;
            </Col>
            <Col className="d-lg-flex justify-content-end">
              <Link to="/newperson">Add person</Link>
            </Col>
          </Row>
          <CardColumns>
            {items.map(item => (
              <Card border="secondary" style={{ width: '18rem' }} key={item.Id} >
                <Card.Header><Link to={`/viewperson/${item.Id}`}>{item.Name}</Link></Card.Header>
                <Card.Body>
                  <Card.Title>Title?</Card.Title>
                  <Card.Subtitle>{item.Description}</Card.Subtitle>
                  <Card.Text>More text...</Card.Text>
                </Card.Body>
                <Card.Footer>
                  <small>Thumbs Up: 0...</small>
                  <Card.Link href="#">Card Link</Card.Link>
                </Card.Footer>
              </Card>
            ))}
          </CardColumns>
        </Container>
      );
    }
  }

}

export default Persons;